import React, { useState, useEffect } from 'react';
import css from './AccordionItem.module.css';

const ChevronDown = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-chevron-down"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const AccordionItem = props => {
  const { header, children, initialEntered = false, className, ...rest } = props;
  const [isEnter, setIsEnter] = useState(initialEntered);
  const [contentHeight, setContentHeight] = useState('0px');
  const [isVisible, setIsVisible] = useState(initialEntered);

  useEffect(() => {
    if (isEnter) {
      const content = document.getElementById(`accordion-content-${header}`);
      setContentHeight(`${content?.scrollHeight}px`);
      setIsVisible(true);
    } else {
      setContentHeight('0px');
      setTimeout(() => setIsVisible(false), 250); // Match transition time
    }
  }, [isEnter, header]);

  const toggleAccordion = () => {
    setIsEnter(!isEnter);
  };

  return (
    <div className={`${css.item} ${className || ''}`} {...rest}>
      <button
        onClick={toggleAccordion}
        className={`${css.itemBtn} ${isEnter ? css.itemBtnExpanded : ''}`}
        aria-expanded={isEnter}
      >
        <article className={css.header}>
          {header}
          <span className={`${css.chevron} ${isEnter ? css.chevronExpanded : ''}`}>
            <ChevronDown />
          </span>
        </article>
      </button>
      <div
        id={`accordion-content-${header}`}
        className={`${css.itemPanel} ${isEnter ? css.itemPanelExpanded : ''}`}
        style={{
          height: contentHeight,
          opacity: isVisible ? 1 : 0,
          overflow: 'hidden',
          transition: 'height 250ms ease-in-out, opacity 250ms ease-in-out',
        }}
      >
        <div className={css.itemContent}>{children}</div>
      </div>
    </div>
  );
};

export default AccordionItem;
